






























































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import DatePicker from "vuejs-datepicker";

import dataStore from "@/store";
import PlushieStore from "@/modules/plushie/store";
import { ProductValue } from "@/modules/plushie/product.value";

import Product from "../../../plushie/product.model";
import ProductSetting from "../../product-setting.model";

@Component({
  components: {
    DatePicker,
  },
})
export default class ProductSettingEditItem extends Vue {
  @Prop({ required: true })
  public readonly periodId!: string;

  @Prop({ required: true })
  public readonly id!: string;

  @Prop({ default: false })
  public readonly disabled!: boolean;

  @Prop({ default: [] })
  public readonly existingProducts!: string[];

  @Prop({ default: true })
  public readonly isNew!: boolean;

  @Prop({ required: false })
  public readonly value?: ProductSetting;

  public internationalDueDate?: Date;
  public domesticDueDate?: Date;
  public product?: ProductValue;

  private fPlushieDataStore: PlushieStore;

  get productOptions(): Product[] {
    const allProducts = this.fPlushieDataStore.activeProductsList;

    const existingProducts = this.existingProducts.filter(
      (item) => item !== this.product
    );

    return allProducts.filter((item) => !existingProducts.includes(item.id));
  }

  constructor() {
    super();

    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  public deleteItem(): void {
    if (this.value && !confirm("Are you sure?")) {
      return;
    }

    this.$emit("delete");
  }

  public getSettingProductName(productId?: string): string {
    if (!productId) {
      return "";
    }

    const product = this.fPlushieDataStore.getProductById(productId);

    return product ? product.name : "";
  }

  public onChange(): void {
    if (!this.product || !this.internationalDueDate || !this.domesticDueDate) {
      this.$emit("input", undefined);
      return;
    }

    const value = new ProductSetting(
      this.id,
      this.periodId,
      this.product,
      this.internationalDueDate,
      this.domesticDueDate
    );

    this.$emit("input", value);
  }

  protected data(): Record<string, unknown> {
    return {
      internationalDueDate: this.internationalDueDate,
      domesticDueDate: this.domesticDueDate,
      product: this.product,
    };
  }

  @Watch("value", { immediate: true })
  private _onValueChange() {
    if (!this.value) {
      return;
    }

    this.internationalDueDate = this.value.internationalDueDate;
    this.domesticDueDate = this.value.domesticDueDate;
    this.product = this.value.product;
  }
}
